<template>
  <div>
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("ebay_documentation_rr_shipping.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>

    <div class="pa-4">
      <h2>{{ $t("ebay_documentation_rr_shipping.overview_title") }}</h2>
      <pre>{{ $t("ebay_documentation_rr_shipping.overview_text") }}</pre>
      <hr class="mb-4" />

      <h2>{{ $t("ebay_documentation_rr_shipping.bulk_title") }}</h2>
      <pre>{{ $t("ebay_documentation_rr_shipping.bulk_text") }}</pre>
      <hr class="mb-4" />

      <h2>{{ $t("ebay_documentation_rr_shipping.manual_title") }}</h2>
      <pre>{{ $t("ebay_documentation_rr_shipping.manual_text") }}</pre>
      <ol class="pl-5 mt-2 mb-4">
        <li>{{ $t("ebay_documentation_rr_shipping.manual_step_1") }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.manual_step_2") }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.manual_step_3") }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.manual_step_4") }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.manual_step_5") }}</li>
      </ol>
      <div class="mt-3 mb-4">
        <img
          src="@/assets/leko/rr_shipping_costs_manual.png"
          :alt="$t('ebay_documentation_rr_shipping.manual_image_alt')"
          class="rr-shipping-doc-img mr-2 mt-2"
          @mousemove="zoomIn"
          @mouseleave="zoomOut"
        />
      </div>
      <v-alert type="info" variant="outlined" border="start" class="mb-2">
        {{ $t("ebay_documentation_rr_shipping.manual_note") }}
      </v-alert>

      <hr class="mb-4 mt-4" />
      <h2>{{ $t("ebay_documentation_rr_shipping.price_display_title") }}</h2>
      <pre>{{ $t("ebay_documentation_rr_shipping.price_display_intro", priceDisplayVars) }}</pre>
      <p class="mb-1">
        {{ $t("ebay_documentation_rr_shipping.price_display_original_formula", priceDisplayVars) }}
      </p>
      <p class="mb-3">
        {{ $t("ebay_documentation_rr_shipping.price_display_final_formula", priceDisplayVars) }}
      </p>
      <p class="mb-1">{{ $t("ebay_documentation_rr_shipping.price_display_discount_title") }}</p>
      <ul class="pl-5 mb-4">
        <li>{{ $t("ebay_documentation_rr_shipping.price_display_discount_band_1", priceDisplayVars) }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.price_display_discount_band_2", priceDisplayVars) }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.price_display_discount_band_3", priceDisplayVars) }}</li>
        <li>{{ $t("ebay_documentation_rr_shipping.price_display_discount_band_4", priceDisplayVars) }}</li>
      </ul>
      <pre>{{ $t("ebay_documentation_rr_shipping.price_display_example", priceDisplayVars) }}</pre>
      <div class="mt-3 mb-4">
        <img
          src="@/assets/leko/rr_price_display_example.png"
          :alt="$t('ebay_documentation_rr_shipping.price_display_image_alt', priceDisplayVars)"
          class="rr-shipping-doc-img mr-2 mt-2"
        />
      </div>
      <pre>{{ $t("ebay_documentation_rr_shipping.price_display_conclusion", priceDisplayVars) }}</pre>
    </div>
  </div>
</template>

<script>
import zoom from "../utils/zoom";

export default {
  data() {
    return {
      rotation: 0,
      priceDisplayVars: {
        feePercent: 7,
        band1Max: "299",
        band1Discount: 20,
        band2Min: "300",
        band2Max: "999",
        band2Discount: 15,
        band3Min: "1000",
        band3Max: "1999",
        band3Discount: 10,
        band4Min: "2000",
        band4Discount: 5,
        exampleP: "25.00",
        exampleShipping: "6",
        exampleOriginal: "32.75",
        exampleFinal: "27.75",
        exampleDiscount: 20,
      },
    };
  },
  methods: {
    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
      event.target.classList.add("zoomed");
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
      event.target.classList.remove("zoomed");
    },
  },
};
</script>

<style scoped>
h2 {
  background-color: #c62828;
  color: white;
  padding: 0.35rem 0.75rem;
  margin-bottom: 0.75rem;
}
pre {
  white-space: pre-wrap;
  font-family: inherit;
  margin: 0 0 0.5rem;
}
.rr-shipping-doc-img {
  max-width: 100%;
  height: auto;
  max-height: 420px;
  border: 1px solid #e0e0e0;
}
</style>
